import { gql } from '@efficiently/client-core-graphql-models';

/**
 * Every Design Change on the caller's current project, newest first.
 *
 * No variables: the project is read server-side from the caller's app context, so no call site can
 * widen the read by naming a different project.
 *
 * Non-null on the wire (`[ProjectDesignChange!]!`) — the list and its members never need a null
 * check. Unlike the detail read below, "nothing to show" arrives as an empty array.
 */
export const PROJECT_DESIGN_CHANGES = gql(`
	query ProjectDesignChanges {
		projectDesignChanges {
			...ProjectDesignChange
		}
	}
`);
